import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexAlert',
  setup(__props) {

const DarkColor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/DarkColor.vue"))
const LightClor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/LightClor.vue"))
const TextAlert = defineAsyncComponent(() => import("@/components/theme/uikits/alert/TextAlert.vue"))
const AlertsSection = defineAsyncComponent(() => import("@/components/theme/uikits/alert/AlertsSection.vue"))
const AdditionalContent = defineAsyncComponent(() => import("@/components/theme/uikits/alert/AdditionalContent.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ui Kits",
      mains: "Alert",
      title: "Alert"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DarkColor)),
        _createVNode(_unref(LightClor)),
        _createVNode(_unref(TextAlert)),
        _createVNode(_unref(AlertsSection)),
        _createVNode(_unref(AdditionalContent))
      ])
    ])
  ], 64))
}
}

})